// src/slices/userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserState {
  uid: string | null; // EOA wallet address (used as Firestore doc ID)
  email: string | null;
  phone: string | null;
  wallet: string | null; // EOA wallet (same as uid)
  smartWallet: string | null; // Smart account address (e.g. Thirdweb)
  username: string | null;
  joinedAt: string | null; // ISO string
  isBusiness?: boolean;
}

const initialState: UserState = {
  uid: null,
  email: null,
  phone: null,
  wallet: null,
  smartWallet: null,
  username: null,
  joinedAt: null,
  isBusiness: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState>) => {
      // Replace entire user state
      return { ...action.payload };
    },

    updateUser: (state, action: PayloadAction<Partial<UserState>>) => {
      // Merge partial updates
      return { ...state, ...action.payload };
    },

    clearUser: () => {
      // Reset to initial state
      return initialState;
    },
  },
});

export const { setUser, updateUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
